import {
  CircularProgress,
  Tabs,
  Typography,
  makeStyles
} from '@material-ui/core';
import Tab from 'components/Base/Tabs/Tab';
import React, { useEffect, useState } from 'react';
import ProviderInformation from './Provider/Forms/ProviderInformation';
import AboutUs from './Provider/Forms/AboutUs';
import Videos from './Provider/Forms/Videos';
import KeyContacts from './Provider/Forms/KeyContacts';
import Resources from './Provider/Forms/Resources';
import Portfolios from './Provider/Forms/Portfolios';
import PlatformAvailability from './Provider/Forms/PlatformAvailability';
import MarketCommentary from './Provider/Forms/MarketCommentary';
import Events from './Provider/Forms/Events';
import Disclaimer from './Provider/Forms/Disclaimer';
import LegalRelationship from './Provider/Forms/LegalRelationship';
import Dashboard from 'components/Layout/Dashboard/Dashboard';
import Router from 'components/Router/Router';
import api from 'api';
import { useHistory } from 'react-router-dom';
import ROUTES from 'consts/routes';

const { useParams } = Router;

const useStyles = makeStyles({
  loaderWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    position: 'absolute',
    left: 0
  },
  content: {
    margin: '2rem auto',
    width: '100%',
    maxWidth: '1500px'
  },
  wrapper: {
    display: 'flex'
  },
  tabWrapper: {
    paddingRight: '1rem',
    borderRight: '1px solid #d4d4d4'
  },
  providerTitle: {
    fontWeight: 700,
    marginBottom: '2rem'
  },
  formWrapper: {
    paddingLeft: '1rem',
    flexGrow: 1
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '1rem'
  },
  alignBaseline: {
    alignItems: 'baseline'
  },
  alignStart: {
    alignItems: 'flex-start'
  },
  label: {
    maxWidth: '250px',
    minWidth: '120px',
    width: '30%'
  },
  fieldWrapper: {
    flexGrow: 1
  },
  title: {
    fontWeight: 700
  },
  modalWrapper: {
    padding: '1rem',
    minWidth: '550px'
  },
  '@global': {
    '.quill .ql-editor': {
      fontFamily: 'Gilroy, Roboto'
    }
  }
});

const Component = () => {
  const classes = useStyles();
  const history = useHistory();
  const { provider } = useParams() as any;
  const [tab, setTab] = useState(0);
  const [providerInfo, setProviderInfo] = useState({} as any);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    api.getMpsProviders().then(({ data }) => {
      const matchedProvider = data.results.find((item: any) => {
        return item.slug === provider;
      });

      if (!matchedProvider) {
        history.push(ROUTES.MPS_HUB.BASE);
        return;
      }

      api.getMpsProviderAdmins().then(({ data }) => {
        const isAdmin = data.results.find(
          (item: any) => item.provider.id === matchedProvider.id
        );

        if (!isAdmin) {
          history.push(ROUTES.MPS_HUB.PROVIDER.replace(':provider', provider));
        }
      });

      api.getMpsProvider(matchedProvider.id).then(({ data }) => {
        setProviderInfo(data);
        localStorage.setItem('providerName', data.name);
        setIsLoading(false);
      });
    });
    // eslint-disable-next-line
  }, []);

  const handleTabChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setTab(newValue);
  };

  const components = [
    { title: 'Provider information', component: ProviderInformation },
    { title: 'About us', component: AboutUs },
    { title: 'Videos', component: Videos },
    { title: 'Key contacts', component: KeyContacts },
    { title: 'Resources', component: Resources },
    { title: 'Portfolios', component: Portfolios },
    { title: 'Platform availability', component: PlatformAvailability },
    { title: 'Market commentary', component: MarketCommentary },
    { title: 'Events', component: Events },
    { title: 'Legal relationship', component: LegalRelationship },
    { title: 'Disclaimer', component: Disclaimer }
  ] as any;

  const CurrentComponent = components[tab].component;

  return (
    <Dashboard>
      {isLoading ? (
        <div className={classes.loaderWrapper}>
          <CircularProgress size="80px" />
        </div>
      ) : (
        <div className={classes.content}>
          <Typography
            className={classes.providerTitle}
            variant="h5"
            component="h1"
          >
            {providerInfo.name} - Update Provider Information
          </Typography>
          <div className={classes.wrapper}>
            <div className={classes.tabWrapper}>
              <Tabs
                orientation="vertical"
                style={{ marginBottom: '2rem' }}
                value={tab}
                onChange={handleTabChange}
                TabIndicatorProps={{
                  style: { display: 'none' }
                }}
              >
                {components.map((component: any, index: number) => (
                  <Tab
                    key={index}
                    label={component.title}
                    id={`simple-tab-${index}`}
                    aria-controls={`simple-tabpanel-${index}`}
                    style={{ textTransform: 'none' }}
                  />
                ))}
              </Tabs>
            </div>

            <div className={classes.formWrapper}>
              <CurrentComponent
                data={providerInfo}
                updateData={setProviderInfo}
                classes={classes}
              />
            </div>
          </div>
        </div>
      )}
    </Dashboard>
  );
};

export default Component;
